import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

/**
 * ClassRecordDetailsEditor works with the Form on the ClassRecord 
 * data page, permitting changing of class type, date, and start/end times.
 */
export class ClassRecordDetailsEditor {
	constructor(classRecordId) {
		this.ClassRecordId = classRecordId;
		this.ClassTypeSelect = document.getElementById('ClassTypeId');
		this.StartTime = document.getElementById('StartTime');
		this.EndTime = document.getElementById('EndTime');
		this.Date = document.getElementById('Date');
		this.Title = document.getElementById('Title');
		this.Notes = document.getElementById('Notes');

		this.ClassTypeSelect.addEventListener('change', (evt)=> {
			evt.preventDefault();
			evt.stopPropagation();
			let sel = this.ClassTypeSelect.options[this.ClassTypeSelect.selectedIndex];
			DojoDeshi.instance().RPC().SetClassRecordType(this.ClassRecordId, parseInt(sel.value))
			.then((res)=>{},(err)=>{
				console.error(err);
				alert('Failed to set Class Record Type: ' + err);
			});
		});

		this.Title.addEventListener('blur', (evt)=> {
			DojoDeshi.instance().RPC().SetClassRecordTitle(this.ClassRecordId, this.Title.value)
			.then((res)=>{}, (err)=>{
				console.error(err);
				alert('Failed to set Title: '+ err);
			});
		});
		this.Notes.addEventListener('blur', (evt)=>{
			DojoDeshi.instance().RPC().SetClassRecordNotes(this.ClassRecordId, this.Notes.value)
			.then((res)=>{}, (err)=>{
				console.error(err);
				alert('Failed to set Notes: '+ err);
			});
		});
		let timesChanged = (evt)=> {
			DojoDeshi.instance().RPC().SetClassRecordTimes(this.ClassRecordId, 
				this.Date.value, this.StartTime.value, this.EndTime.value)
			.then((res)=>{}, (err)=>{
				console.error(err);
				alert('Failed to set Class Record Times: ' + err);
			})
		}
		this.Date.addEventListener('blur',timesChanged);
		this.StartTime.addEventListener('blur', timesChanged);
		this.EndTime.addEventListener('blur', timesChanged);
	}
}

window.ClassRecordDetailsEditor = ClassRecordDetailsEditor;